import React from 'react';
import Styled from 'styled-components';
import slider from '@material-ui/core/Slider';

const Slider = Styled(slider)`
  && {
    height: 10px;
    padding: 0;

    .MuiSlider-rail,
    .MuiSlider-track,
    .MuiSlider-mark {
      height: 10px;
    }
    
    .MuiSlider-rail {
      border-radius: 10px;
      background: linear-gradient(90deg, rgba(212,65,65,1) 0%, rgba(17,158,221,1) 100%);
      opacity: 1;
    }

    .MuiSlider-track {
      display: none;
    }

    .MuiSlider-mark, .MuiSlider-mark.MuiSlider-markActive {
      background-color: white;
    }

    .MuiSlider-markLabel {
      display: none;
    }

    .MuiSlider-thumb {
      height: 24px;
      width: 24px;
      border: 3px solid white;
      transform: translate(-25%, -3px);
    }

    .MuiSlider-thumb.Mui-focusVisible, .MuiSlider-thumb:hover {
      box-shadow: unset;
    }

    .MuiSlider-thumb {
      color: ${({ theme }) => theme.colors.secondary.blue};

      .MuiSlider-valueLabel {
        background-color: currentColor;
        border-radius: 3px;

        > span {
          border-bottom-left-radius: 2px;
        }
      }
    }
  }
`;

// TODO: extract this into props
const marks = [
  { value: -4 },
  { value: -3 },
  { value: -2 },
  { value: -1 },
  { value: 0 },
  { value: 1 },
  { value: 2 },
  { value: 3 },
  { value: 4 },
];

declare type Props = {
  className?: string;
  name: string;
  onChange?: (event: React.ChangeEvent, value: number | number[]) => void;
};

const RangeSlider = ({ className, name, onChange }: Props) => {
  return (
    <Slider
      className={className}
      step={1}
      min={-5}
      max={5}
      defaultValue={0}
      valueLabelDisplay="auto"
      marks={marks}
      name={name}
      onChange={onChange}
    />
  );
};

export default RangeSlider;
